const FormStaticTextConfig = {
  componentType: 'FORM_STATIC_TEXT',
  widgetConfig: {
    icon: 'x-lib-static-text',
    text: '静态文本',
    description: '用于展示页面提示文字，最大长度限制2000字符'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12,
    height: 1,
    lengthLimit: 2000,
    textColor: '#B2B2B2',
    render: {
      ide: 'FormStaticText',
      edit: 'FormStaticText',
      read: 'FormStaticText'
    }
  },
  editorConfig: ['INFO', 'STATIC_TEXT_DEFAULT', 'TEXT_COLOR', 'HIDDEN']
}

export default FormStaticTextConfig
